import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';
import {push as changeURL} from 'react-router-redux';
import isEmpty from 'lodash/isEmpty';

import * as urls from '~/routing/urls';
import * as modes from '~/modules/modal/modes';
import {modalChange} from '~/modules/modal/actions';
import mapDispatch from '~/misc/mapDispatch';
import {getQuery} from '~/misc/getQuery';
import {errorInfoConfig} from '~/misc/error-info';
import Ratio from './Ratio';
import RateCheck from './RateCheck';
import Calculator from './Calculator';

import sharedCSS from '~/components/shared.css';
import css from './index.css';

class AddressAndEqipInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      renderChild: false,
      fromRoute: '',
      fromQuery: {},
      formData: {
        origin: '',
        destination: '',
        fuelPrice: 0,
        basePrice: 1.15,
        milesPrice: 5.5,
      },
      formError: {},
    };

    this.renderHeader = this.renderHeader.bind(this);
    this.renderBody = this.renderBody.bind(this);
    this.setRouteOrigin = this.setRouteOrigin.bind(this);
    this.judgeRoute = this.judgeRoute.bind(this);

    this.canClickOrNot = this.canClickOrNot.bind(this);
    this.clickAndJump = this.clickAndJump.bind(this);
    this.onSubM = this.onSubM.bind(this);
  }

  componentWillMount() {
    let pathUrl = window.location.pathname;
    // 初始化equipment值
    if (pathUrl === urls.RATEINSPECTION || pathUrl === urls.LOADRATIO) {
      this.setState({
        formData: Object.assign({}, this.state.formData, {equipment: 'Flatbed'}),
      });
    }

    this.setRouteOrigin();
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.routing.pathname !== nextProps.routing.pathname) {
      return this.setState({
        renderChild: false,
        fromQuery: {},
        fromRoute: nextProps.routing.pathname,
        formData: Object.assign({}, this.state.formData, {origin: '', destination: '', equipment: 'Flatbed'}),
        formError: Object.assign({}, this.state.formError, {origin: '', destination: '', equipment: ''}),
      });
    }

    if (this.props.routing !== nextProps.routing) {
      return this.setRouteOrigin();
    }
    return null;
  }

  render() {
    return this.renderContent();
  }

  renderContent() {
    const renderChild = this.state.renderChild;
    const childrenWithProps = React.Children.map(
      this.props.children,
      (child) => React.cloneElement(
        child,
        {
          user: this.props.user,
          parentState: this.state,
          routing: this.props.routing,
        }
      )
    );

    if (renderChild) {
      return (<div>{childrenWithProps}</div>);
    }

    return (
      <div className={cs(sharedCSS.wideStretchable, sharedCSS.box, sharedCSS.unpadded, css.main)}>
        <h2 className={css.rateHeader}>{ this.renderHeader() }</h2>
        {
          this.renderBody()
        }
      </div>
    );
  }

  renderBody() {
    const fromRoute = this.state.fromRoute;
    if (fromRoute === urls.RATEINSPECTION) {
      return <RateCheck login={this.props.login} goToRate={this.props.goToRate}/>;
    }
    if (fromRoute === urls.LOADRATIO) {
      return <Ratio login={this.props.login} goToRate={this.props.goToRate}/>;
    }
    if (fromRoute === urls.CALCULATOR) {
      return <Calculator login={this.props.login} goToRate={this.props.goToRate}/>;
    }
    return null;
  }

  renderHeader() {
    const fromRoute = this.state.fromRoute;
    if (fromRoute === urls.RATEINSPECTION) {
      return 'Rate Check';
    }
    if (fromRoute === urls.LOADRATIO) {
      return 'Truck to Load Ratio';
    }
    if (fromRoute === urls.CALCULATOR) {
      return 'Fuel Surcharge Calculator';
    }
    return null;
  }

  setRouteOrigin() {
    let pathUrl = window.location.pathname;

    if (pathUrl === '/info') {
      return this.props.initRoute();
    }

    this.judgeRoute();
    return null;
  }

  judgeRoute() {
    const param = getQuery(window.location.href).param;
    const fromQuery = param ? JSON.parse(decodeURIComponent(param)) : {};
    let pathUrl = window.location.pathname;

    if (pathUrl === urls.CALCULATOR) {
      return this.setState({
        fromRoute: pathUrl,
        fromQuery: fromQuery,
        renderChild: !isEmpty(fromQuery)
          && !isEmpty(fromQuery.origin)
          && !isEmpty(fromQuery.destination)
          && Boolean(fromQuery.fuelPrice)
          && Boolean(fromQuery.basePrice)
          && Boolean(fromQuery.milesPrice),
      });
    }
    return this.setState({
      fromRoute: pathUrl,
      fromQuery: fromQuery,
      renderChild: !isEmpty(fromQuery)
        && !isEmpty(fromQuery.origin)
        && !isEmpty(fromQuery.destination)
        && Boolean(fromQuery.equipment),
    });
  }

  canClickOrNot(formData, formError) {
    let canNotClick = false;
    Object.keys(formData).forEach((key) => {
      if (key === 'origin' || key === 'destination') {
        if (isEmpty(formData[key])) {
          canNotClick = true;
          formError[key] = errorInfoConfig.text.empty;
          return;
        }
        if (!formData[key].is_city) {
          canNotClick = true;
          formError[key] = 'Wrong city!';
          return;
        }
      }
      if (!formData[key] || formError[key]) {
        canNotClick = true;
        formError[key] = formError[key] ? formError[key] : errorInfoConfig.text.empty;
        return;
      }
    });
    return {
      canNotClick,
      formError,
    };
  }

  clickAndJump(formData, formError) {
    const judgeClick = this.canClickOrNot(formData, formError);
    if (judgeClick.canNotClick) {
      return this.setState({
        formError: Object.assign({}, formError, judgeClick.formError),
      });
    }
    return this.props.goToRate(formData, this.state.fromRoute);
  }

  onSubM() {
    const formData = this.state.formData;
    const formError = this.state.formError;

    const formDataCheckAndRatio = {
      origin: formData.origin,
      destination: formData.destination,
      equipment: formData.equipment,
    };

    const calcFormData = {
      origin: formData.origin,
      destination: formData.destination,
      fuelPrice: formData.fuelPrice,
      basePrice: formData.basePrice,
      milesPrice: formData.milesPrice,
    };

    if (this.state.fromRoute === urls.RATEINSPECTION || this.state.fromRoute === urls.LOADRATIO) {
      this.clickAndJump(formDataCheckAndRatio, formError);
    }

    if (this.state.fromRoute === urls.CALCULATOR) {
      this.clickAndJump(calcFormData, formError);
    }
  }
}

export default connect(({user, routing}) => ({user, routing}), mapDispatch({
  login: () => modalChange(modes.LOGIN, 'navbar'),
  initRoute: () => changeURL(`${urls.RATEINSPECTION}`),
  goToRate: (props, formData) => changeURL(`${window.location.pathname}?param=${JSON.stringify(formData)}`),
}))(AddressAndEqipInfo);





// WEBPACK FOOTER //
// ./src/components/rate/AddressAndEqipInfo/index.js